<script lang="ts" setup></script>

<template>
  <div class="rounded border bg-surface">
    <slot />
  </div>
</template>

<style scoped></style>
